export default __webpack_public_path__ + "static/media/mockupBilling1.f8f17cee.png";